import React from 'react';
import { Link } from 'react-router-dom';
import './courses.css';
import CourseBanner from '../components/CourseBanner';

const PhysicalDesign = () => {
    return (
        <div className="course-page">
            <section className="course-hero" data-aos="fade-up">
                <h1>Physical Design <span>Training</span></h1>
                <p>Master the art of transforming RTL into silicon-ready layouts.</p>
            </section>

            <CourseBanner />

            <section className="course-selection">
                <div className="course-grid">
                    <div className="course-card glass" data-aos="fade-right">
                        <div className="card-top">
                            <span className="duration">41 Days Training</span>
                            <h3>Long Term Course</h3>
                        </div>
                        <p>Complete SYN_PNR_STA curriculum including Synthesis, PNR, Timing, and Lab sessions.</p>
                        <div className="card-footer">
                            <span className="fee"></span>
                            <Link to="/courses/physical-design/long-term" className="btn btn-gold">View Details</Link>
                        </div>
                    </div>

                    <div className="course-card glass" data-aos="fade-left">
                        <div className="card-top">
                            <span className="duration">11 Days Crash Course</span>
                            <h3>Short Term Course</h3>
                        </div>
                        <p>Intensive training on Timing Analysis, PNR basics, and Tool sessions.</p>
                        <div className="card-footer">
                            <span className="fee"></span>
                            <Link to="/courses/physical-design/short-term" className="btn btn-primary">View Details</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PhysicalDesign;